import React from 'react';
import { AuthAction, AuthPayloadSuccess } from '../../lib/authenticate';
import { SocialAuthProvider } from '../../hooks/useSocialAuth';
import { useCountry } from '../CountrySelector';
import { SocialAuthButton } from './SocialAuthButton';

type Props = {
  action: AuthAction;
  showAuthModal?: () => void;
  hideAuthModal?: () => void;
  showAmazonMessage?: boolean;
  onAuth?: (authUser?: AuthPayloadSuccess) => void;
};

export const SocialAuthButtons: React.FC<Props> = ({
  action,
  showAuthModal,
  hideAuthModal,
  showAmazonMessage,
  onAuth
}) => {
  const {
    country: { currencyCode }
  } = useCountry();

  return (
    <>
      {currencyCode === 'USD' && (
        <SocialAuthButton
          action={action}
          provider={SocialAuthProvider.Amazon}
          message={
            showAmazonMessage
              ? 'Sign in with your Amazon account details to use your saved delivery and payment information.'
              : undefined
          }
          showAuthModal={showAuthModal}
          hideAuthModal={hideAuthModal}
          onAuth={onAuth}
        />
      )}
      <SocialAuthButton
        action={action}
        provider={SocialAuthProvider.Facebook}
        showAuthModal={showAuthModal}
        hideAuthModal={hideAuthModal}
        onAuth={onAuth}
      />
    </>
  );
};
